import {
  AppText,
  Button,
  CustomContainer,
  FlexColumn,
  FlexRow,
} from "src/style";
import Logo from "../../assets/svg/cbp-dashboardlogo";
import { useState } from "react";
import { moneyFormat } from "src/utils/utility";

interface DashboardProps {
  accounts: { balance: string }[];
}

export const CbpDashboardCard = ({ accounts }: DashboardProps) => {
  const [activeIndex, setActiveIndex] = useState(0);
  return (
    <FlexColumn alignItems="flex-start">
       {accounts.length > 0 && (
        <DashboardCard balance={accounts[activeIndex]?.balance} />
      )}

        <FlexRow style={{position:'absolute', bottom:-40}}>
          {accounts?.map((_, index: number) => (
            <Button
              key={index}
              height="0.7"
              width="0.7"
              radius="1"
              rightMargin="0.5"
              bgColor={index === activeIndex ? "#0D968F" : "#E7F6F5"}
              onClick={() => setActiveIndex(index)} 
            />
          ))}
        </FlexRow>
    </FlexColumn>
  );
};


type CardProp ={
    balance : string
}
const DashboardCard = ({balance}:CardProp) => {
  return (
    <>
      <FlexColumn
        width="35"
        height="5"
        radius="2"
        bgColor="#67696a"
        style={{ position: "absolute", bottom: -8, left: 20 }}
      />
      <FlexColumn
        width="45"
        radius="1"
        height="11"
        padding="3"
        bgColor="#0D968F"
        alignItems="flex-start"
        borderColor="#EAECF0"
        borderWidth="1"
        zIndex="1"
      >
        <FlexRow justifyContent="space-between">
          <FlexColumn alignItems="start">
            <AppText color="#fff" fontWeight="400" textSize="1.5">
              Qore current account
            </AppText>
            <AppText color="#fff" fontWeight="700" textSize="2">
            {moneyFormat(balance,false, 'NGN')}
            </AppText>
          </FlexColumn>

          <FlexRow
            bgColor="#E7F6F5"
            width="30"
            height="4"
            radius="3"
            justifyContent="center"
          >
            <AppText color="#0A756F" fontWeight="600" textSize="1.8">
              + Convert Money
            </AppText>
          </FlexRow>

          <FlexColumn
            bgColor="#0A756F"
            style={{ position: "absolute", top: -40, right: -31 }}
            width="9"
            height="10"
            radius="1"
          >
            <Logo />
          </FlexColumn>
        </FlexRow>
      </FlexColumn>
    </>
  );
};
